import { Component, Input } from '@angular/core';
import { ProjectEpicModel } from 'src/app/shared';

@Component({
  selector: 'app-epic-label',
  template: `
    <div class="custom-option">
      <span
        class="badge-label text-ellipsis"
        [ngStyle]="{ 'background-color': item.colorCode }"
        >{{ item.name }}</span
      >
    </div>
  `
})
export class EpicLabelComponent {
  @Input() item: ProjectEpicModel;
}
